import React, { useState } from 'react';
import '../styles/Window.css';

const Window = ({ isDarkMode, heading, content, onClose, onMinimise, isMinimised, onMaximise, isMaximised, style }) => {
    return (
        <div className={`window ${isDarkMode ? 'window-dark' : 'window-light'} ${isMaximised ? 'maximised' : 'not-maximised'} ${isMinimised ? 'minimised' : ''}`} style={style}>
            {/* Window bar header */}
            <div className={`bar ${isDarkMode ? 'bar-dark' : 'bar-light'}`}>
                {/* Buttons */}
                <div className='button-container'>
                    <div className='button close-button' onClick={onClose}/>
                    <div className='button min-button' onClick={onMinimise}/>
                    <div className='button expand-button' onClick={onMaximise}/>
                </div>
                {/* Title */}
                <p className={`bar-title ${isDarkMode ? 'title-dark' : 'title-light'}`}>{heading}</p>
            </div>
            <div className={`${isMinimised ? 'content-hide' : 'content'}`}>
                {/* Main content */}
                {content}
            </div>
        </div>
    );
};

export default Window;